import React from 'react';

const VerificationConfirmation = () => {
    return (
        <div>
            <h5 className="mb-3 text-center text-xl font-medium text-foreground">
                Your account has been created!
            </h5>
            <p className="text-center text-base font-light text-foreground">
                Click the 'Login' tab above to sign in.
            </p>
        </div>
    );
};

export default VerificationConfirmation;
